/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import datos from "../../assets/items_arnes_produced.json"


// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import IconButton from '@mui/material/IconButton';
import Icon from "@mui/material/Icon";
import ConfirmDialog from "components/ConfirmDialog";
import TableSkeleton from "components/TableSkeleton";
import CustomAlert from "components/CustomAlert";
import TokenApi from "components/TokenApi";
import CustomInput from "components/MDInputField/CustomInput";
import DinamicDate from "components/DinamicDateFields";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from "@mui/material/Backdrop";
import axios from 'axios';

// Data
import { useEffect, useState, useMemo } from "react";
import { RoleAPI } from "api/RoleAPI";
import { ProarnesAPI } from "api/ProarnesAPI";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import permissions from "permissions";


function ArnesProduced() {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state;
  const [roles, setRoles] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [id, setId] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const { user, loading, admin } = controller;
  const [formData, setFormData] = useState({});
  const [fields, setFields] = useState([]);


  const [archivo, setArchivo] = useState(null);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });

  const BASE_URL = process.env.REACT_APP_API_YEMINUS;
  const USER_PASSWORD = process.env.REACT_APP_PASS_YEMINUS;
  const { token, authenticate, COMPANY_ID, USER_ID } = TokenApi();

  const [searchTerm, setSearchTerm] = useState("");
  const [originalRows, setOriginalRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  

  const productos = datos;
 

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  // buscador
  
  useEffect(() => {
    if (searchTerm === "") {
      setFilteredRows(originalRows);
    } else {
      const filtered = originalRows.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setFilteredRows(filtered);
    }
  }, [searchTerm, originalRows]);
  
  // buscador

  useEffect(() => {
    setTableData((prev) => ({
      ...prev,
      rows: filteredRows,
    }));
  }, [filteredRows]);


  useEffect(() => {
    const fetchToken = async () => {
      await authenticate(); 
    };
  
    fetchToken();
  }, []);

  useEffect(() => {
      let fields = [
      { label: 'Fecha Inicio', codigo: 'DESDE_DD/MM/YYYY', tipo: 'date', valor: '' },
      { label: 'Fecha Fin', codigo: 'HASTA_DD/MM/YYYY', tipo: 'date', valor: '' }
      ];

    setFields(fields);

    }, []);

//   useEffect(() => {

//     let fields = [
//       { label: 'Fecha Inicio', codigo: 'DESDE DD/MM/YYYY', tipo: 'date', valor: '' },
//       { label: 'Fecha Fin', codigo: 'HASTA DD/MM/YYYY', tipo: 'date', valor: '' }
//       ];
//     setFields(fields); 

//   }, []);

//   useEffect(() => {
//     const columns = [
//         { Header: "Código de arnés", accessor: "Código de arnés" },
//         { Header: "Descripción", accessor: "Descripción" },
//         { Header: "Código materia prima", accessor: "Código materia prima" },
//         { Header: "Descripción materia prima", accessor: "Descripción materia prima" },
//         { Header: "Referencia", accessor: "Referencia" },
//         { Header: "Cantidad de materia prima utilizada", accessor: "Cantidad de materia prima utilizada" },
//     ];

//     const rows = productos;

//     setTableData({ columns, rows });
// }, []);

const getTokenIfNeeded = async () => {
  if (token) return token;

  console.log("Token no disponible, autenticando...");
  const newToken = await authenticate();
  if (!newToken) {
    console.error("No se pudo obtener el token.");
    return null;
  }

  return newToken;
};



const importarDatos = async () => {
  dispatch({ type: "LOADING", value: true });
  const fechaInicio = formData["DESDE_DD/MM/YYYY"];
  const fechaFin = formData["HASTA_DD/MM/YYYY"];

  if (!fechaInicio || !fechaFin) {
    // alert("Por favor completa ambas fechas antes de importar los datos.");
    handleAlert("debe diligenciar ambos campos de fechas", 'error');
    setLoading(dispatch, false);
    return;
  }

  const currentToken = await getTokenIfNeeded();
  if (!currentToken) return;

  const headers = {
    'Authorization': `Bearer ${currentToken}`,
    'id_empresa': COMPANY_ID,
    'usuario': USER_ID,
    'Content-Type': 'application/json',
  };

  const body = {
    crearArchivo: false,
    idInforme: 31,
    filtroVariableInforme: [],
    variablesFiltro: [
      { codigo: "DESDE_DD/MM/YYYY", valor: fechaInicio },
      { codigo: "HASTA_DD/MM/YYYY", valor: fechaFin }
    ]
  };

  const fullUrl = `${BASE_URL}/app/informes/informespersonalizados/ejecutarconsultainforme`;

  try {
    const response = await axios.post(fullUrl, body, { headers });

    if (response.data && response.data.datos && response.data.datos.length > 0) {
      setOriginalRows(response.data.datos); 
      setFilteredRows(response.data.datos); 
      setTableData({
        columns: [
          { Header: "Codigo arnes", accessor: "codigoarnes" },
          { Header: "Referencia arnes", accessor: "referenciaarnes" },
          { Header: "Descripción", accessor: "nombrearnes" },
          { Header: "Cantida producida", accessor: "cantidadproducida" },
          { Header: "Codigo materia prima", accessor: "codigomateriaprima" },
          { Header: "Nombra materia prima", accessor: "nombremateriaprima" },
          { Header: "Referencia materia prima", accessor: "referenciamateriaprima" },
          { Header: "Cantidad materia prima consumida", accessor: "cantidadmateriaprimaconsumida" },
        ],
        rows: response.data.datos
      });
    } else {
      console.log("No se encontraron datos.");
    }
  } catch (error) {
    console.error("Error al obtener los datos:", error);
  }
  setLoading(dispatch, false);
};



const handleInputChange = (e) => {
  console.log(e.target.value);
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};


  const handleAlertClose = () => setAlert(false);

  const handleClick = () => {
    navigate('create');
  }

  const handleDelete = (id) => {
    setId(id)
    setIsDeleting(true);
  }

  const handleCancelDelete = () => {
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    return deleteRole(id)
  };

 

  const deleteRole = (id) => {
    return RoleAPI.delete(id)
      .then(response => {
        const updatedRoles = roles.filter((role) => role.id !== response.role);
        setRoles(updatedRoles);
        handleAlert(response.message, 'success');
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        handleCancelDelete();
      });
  }

  const getRoles = (signal) => {
    return RoleAPI.index(signal)
      .then(response => {
        setRoles(response.roles)
      }).catch(error => {
        if (error.response)
          handleAlert(error.response.data.message, 'error')
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);

 
  const fetchData = async () => {
    let currentToken = token;
  
    if (!currentToken) {
      currentToken = await authenticate();
    }
  
    if (!currentToken) {
      console.error("No se pudo obtener el token");
      return;
    }
  
    const headers = {
      Authorization: `Bearer ${currentToken}`,
      id_empresa: COMPANY_ID,
      usuario: USER_ID,
      "Content-Type": "application/json",
    };
  

  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            
            {/* <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions?.includes(permissions.roles[1]) || user?.role === admin) && (
                <MDButton variant="gradient" color="info" onClick={handleClick}> Crear Rol</MDButton>
              )}
            </MDBox> */}
             

            <MDBox mb={4} px={2}>
              <CustomAlert severity="secondary" message="En este sitio se pueden ver el listado de arneses producidos en un rango de fechas." open="true" onClose={handleAlertClose}></CustomAlert>
            </MDBox>

            <Card>

            
            <MDBox pt={5} mb={5} ml={4} display="flex" justifyContent="space-around" alignItems="center">
              {/* para botones de fechas */}
              <Grid item xs={12} sm={6} >
                <MDBox p={5} >
                  {fields && (
                    <Grid container spacing={2}>
                      {fields.map((field, index) => (
                        <Grid key={index} item xs={12} sm={6}>
                          <DinamicDate 
                            fields={[field]} 
                            handleInputChange={handleInputChange} 
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </MDBox>
              </Grid>
              {/* para botones de fechas */}

              {/* Contenedor del botón con flexbox para centrar */}
              <Grid item xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
                <MDButton
                  variant="gradient"
                  color="info"
                  size="medium"
                  sx={{
                    minWidth: "150px",
                    height: "45px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "1rem",
                    mt: 2, // Margen superior
                  }}
                  onClick={importarDatos}
                >
                  Importar datos
                </MDButton>
              </Grid>
            </MDBox>


              <MDBox mt={5} mb={5}  display="flex" justifyContent="center">
              <MDBox width="50%">

              </MDBox>
            </MDBox>

              {archivo && (
                <MDBox mt={2} textAlign="center">
                  <MDTypography variant="body1">Archivo seleccionado: {archivo.name}</MDTypography>
                </MDBox>
              )}

            </Card>

            {isDeleting && (<ConfirmDialog onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} ></ConfirmDialog>)}
          </Grid>
        </Grid>

          {/* tabla para visualizar lo cargado de la respuseta del servidor */}
          <Grid container justifyContent="left" mt={4} pb={3}>
          <MDBox display="flex" justifyContent="flex-end" px={2} mb={2}>
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '300px',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              outline: 'none',
              transition: '0.2s all ease',
            }}
            />
          </MDBox>
          </Grid>
          
          <Grid container justifyContent="center" mt={4} pb={3}>
            
            <MDBox sx={{ width: '100%' }}>
              {tableData.columns.length > 0 && (
                <Card sx={{ marginTop: '20px' }}>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Listado de arneses producidos en un rango de fechas
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={3}>
                    <DataTable
                      table={tableData}
                      isSorted={true}
                      entriesPerPage={true}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              )}
            </MDBox>
          </Grid>

          {/* tabla para visualizar lo cargado */}


          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ArnesProduced;